














import Component from 'vue-class-component'
import {Prop, Watch, Vue, Emit, Inject} from 'vue-property-decorator'

import OrderTable from './OrderTable.vue'
import OrderSearch from "./OrderSearchOneLine.vue";
import {
    OrderDuration,
    OrderStatus,
    Portfolio} from "../../domain/types";
import TradingBlockRemote, {
    GetRefClientId,
    Filter,
    OrderResponse,
    GetQuotesForOrders, addQuotesToOrders, GetQuotesForEliteOrders
} from "../../services/TradingBlockRemote";
import {EventBus, Messages, OrderBus, OrderMessages} from "../../services/EventBus";
import RefreshButton from "../Common/RefreshButton.vue";
import {error} from "../../utils/log";
import {extractJsonDate, formatDate} from "../../utils/formatters";
import {ErrorCodeMap, OrderClassMap, OrderDurationMap, OrderStatusMap, OrderTypeMap} from "../../domain/TbMaps";
import {CancelOrderRequest, EditOrderRequest} from "../../domain/DTO";
import {Order, TableOrder} from "../../domain/Order";
import EliteOrdersService from "../../services/EliteOrders";
import {addDays} from "../../utils/vue_utils";

@Component({
    components: {RefreshButton, OrderSearch, OrderTable}
})

class EliteOrdersBlock extends Vue {
    loading: boolean = false;
    loaded: boolean = false;
    filter: Filter = {pageIndex: 0, pageSize:50} as Filter;
    xhr: XMLHttpRequest|null=null;
    orders: TableOrder[]=[];
    totalCount: number = 0;
    @Prop()
    portfolio: Portfolio;

    //navigation
    get totalPages(){
        if (this.totalCount  && this.filter && this.filter.pageSize)
            return Math.ceil(this.totalCount / (this.filter!.pageSize? this.filter!.pageSize!: 50));
    }

    navigate(i:number){
        this.filter.pageIndex = i - 1;
        this.load(this.filter);
    }

    created(){            
        let orig = new Date();
        let targetOffset = 5*60*60*1000;
        //let localOffset = (new Date()).getTimezoneOffset()*60*1000;

        orig.setTime(orig.getTime()- targetOffset);

        var dat = (orig).toISOString().split('T')[0];
        //var nextDay = addDays(orig,1).toISOString().split('T')[0];


        this.filter.dateFrom = dat;
        this.filter.dateTo = dat;
        this.refresh();             
    }

    refresh(){
        OrderBus.$emit(<string>OrderMessages.OrdersRefresh);
        this.filter.pageIndex = 0;
        this.load(this.filter);
    }

    async load(filter: Filter, ev?:any){
        this.filter = filter;

        this.loading = true;
        this.filter.ExcludeDurationId = OrderDuration.Manual;



        let query:Filter = {...this.filter} as Filter;
        if (this.filter.dateTo){
            let orig =new Date(this.filter.dateTo);
            // move to utc
            //orig.setTime(orig.getTime()+orig.getTimezoneOffset()*60*1000);

            query.dateTo=
                addDays(orig,1).toISOString().split('T')[0];
        }

        if (this.filter.dateFrom) {
            let orig =new Date(this.filter.dateFrom);
            //orig.setTime(orig.getTime()+orig.getTimezoneOffset()*60*1000);
            query.dateFrom = orig.toISOString().split('T')[0];
        }


        if (query.WorkingOrdersOnly) query.WorkingOrdersOnly=true; else delete query.WorkingOrdersOnly;

        try {
            const response = await EliteOrdersService.loadOrders(this.portfolio.id, query);
            let payload = response.Payload;                
            this.totalCount = payload!.TotalNumOfAvailableItems;
            const quotes = await GetQuotesForEliteOrders(this.portfolio.id, payload);
            for (let i = 0; i < payload.Items.length; i++) {
                payload.Items[i].OrderId = i;
            }
            this.orders = addQuotesToOrders(payload, quotes);                
            this.loaded = true;
            this.loading = false;
            this.ErrorMessage ="";
            //this.$store.commit('orders/loadedOrders', this.orders);
        } catch (status) {
            error.log("Orders load fail with "+status);
            this.loaded = false;
            this.loading = false;
            const statusNumber = <number>status;
            if (statusNumber>0)
                this.ErrorMessage=ErrorCodeMap[statusNumber];
            else
                this.ErrorMessage ="Server or network error: "+ Math.abs(statusNumber) + ". Please, report via email";

        }

    }

    ErrorMessage:string="";
    name='OrdersBlock'
}

export default EliteOrdersBlock;
